import easyCheckApi from '../api/config';

// Cached promise so the layout, routes and pages share one fetch per session.
let permissionsPromise = null;

const DISABLED_STATE = { enabled: false, role: '', permissions: null };

const fetchMyPermissions = async () => {
  try {
    const response = await easyCheckApi.get('/users/me/permissions');
    const responseData = response.data;
    const data = responseData.Data || responseData.data || responseData;
    return {
      enabled: data.Enabled ?? data.enabled ?? false,
      role: data.Role ?? data.role ?? '',
      permissions: data.Permissions ?? data.permissions ?? null,
    };
  } catch (error) {
    // 404 (backend not deployed) or any error -> behave exactly as today
    return { ...DISABLED_STATE };
  }
};

export const userPermissionsService = {
  /** Current user's permission state; cached until clearCache(). Never rejects. */
  getMyPermissions: () => {
    if (!permissionsPromise) {
      permissionsPromise = fetchMyPermissions();
    }
    return permissionsPromise;
  },

  /** Call on logout and after an admin saves permission changes. */
  clearCache: () => {
    permissionsPromise = null;
  },

  /** Admin: set a user's module permissions. permissions = null grants full access. */
  updateUserPermissions: async (userId, permissions) => {
    const response = await easyCheckApi.put(`/users/${userId}/permissions`, { permissions });
    return response.data;
  },
};

export default userPermissionsService;
